<template>
  <slot />
</template>

<script setup lang="ts">
import { onMounted, watch } from 'vue'
import { useColors } from 'vuestic-ui'
import { useDesignSystem } from '@/composables/useDesignSystem'

const { applyPreset } = useColors()
const { isDark } = useDesignSystem()

function applyVuesticPreset() {
  applyPreset(isDark.value ? 'dark' : 'light')
}

onMounted(applyVuesticPreset)
watch(isDark, applyVuesticPreset)
</script>
